import React from 'react';
import { useClient } from '../../../../hooks/useClient';
import useScreenSize from '../../../../hooks/useScreenSize';
import {
  LinkPlaceholder,
  ResultBlockTitle,
  TitleContainer,
  TitlePlaceholder
} from './styled';
import { ShowAllTextButton } from './ShowAllButton';
import { ItemsSortingFilter } from '../../../NewSearch/NewSearchBar/SortingFilter/ItemsSortingFilter';
import { ItemConnectionSort } from '../../../../graphql/graphql';

interface ResultBlockTitleProps {
  title: string;
  showAllAdsText: string;
  showAllHref?: string;
  loading: boolean;
  isSortingLoading: boolean;
  isShowButton: boolean;
  isShowSorting: boolean;
  sortingValue: ItemConnectionSort;
  showAllResultHandler: () => void;
  onSortChange: (value: ItemConnectionSort) => void;
}

export const AgencyFilterResultBlockTitle: React.FC<ResultBlockTitleProps> = ({
  title,
  showAllAdsText,
  showAllHref,
  loading,
  isSortingLoading,
  isShowButton,
  isShowSorting,
  sortingValue,
  showAllResultHandler,
  onSortChange
}) => {
  const isClient = useClient();
  const { isSmall, isSmallOrLargeDesktop } = useScreenSize();

  if (loading && !isSortingLoading) {
    return (
      <TitleContainer>
        <TitlePlaceholder
          width="150px"
          height="22px"
          margin="0"
          borderRadius="14px"
        />
        <LinkPlaceholder
          width="250px"
          height="22px"
          margin="0"
          borderRadius="14px"
        />
      </TitleContainer>
    );
  }

  return (
    <TitleContainer>
      {title && (
        <ResultBlockTitle
          data-cy="agency-filter__results-block__header"
          tag={isSmallOrLargeDesktop || !isClient ? 'h2' : 'h3'}
        >
          {title}
        </ResultBlockTitle>
      )}

      {(!isSmall || !isClient) && isShowButton && !isShowSorting && (
        <ShowAllTextButton
          text={showAllAdsText}
          href={showAllHref}
          onClick={showAllResultHandler}
        />
      )}

      {isShowSorting && (
        <ItemsSortingFilter
          currentSortValue={sortingValue}
          dataStat="agency"
          showIcon={(!isSmall && isClient) || !isClient}
          submitOnChange
          onChange={onSortChange}
        />
      )}
    </TitleContainer>
  );
};
